import axios from "axios";
import Toaster from "toastr";
import formUrlEncoded from "form-urlencoded";

import { token } from "./token";
import Messages from "../configurations/messages";

let cancel;
const request = {};
let CancelToken = axios.CancelToken;
let isDev = process.env.NODE_ENV === "development";
let isProd = process.env.NODE_ENV === "production";

let xsrfToken = document.getElementById("csrf-token")
  ? document.getElementById("csrf-token").getAttribute("content")
  : "";
let xsrfTokenHeader = document.getElementById("csrf-token")
  ? document.getElementById("csrf-header").getAttribute("content")
  : "";

// Add Session Timeout  Interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data &&
      (error.response.data.message === "SESSION_TIMEOUT" ||
        error.response.data.code === 440)
    ) {
      //Session Timeout
      location.replace(location.href); //Refresh page to reload/show login
      Toaster.error(Messages.SESSION_TIMEOUT);
    }
    return Promise.reject(error);
  }
);

request.make = (ops) => {
  let options = ops || {};
  let isEnCoded = ops.encode;
  let headers = {};
  options.headers = options.headers || {};
  headers = {
    ...options.headers,
    "Content-type": isEnCoded
      ? "application/x-www-form-urlencoded"
      : "application/json",
  };
  // headers[xsrfTokenHeader] = xsrfToken;

  if (isDev) {
    headers["Authorization"] = `Bearer ${token}`;
    headers["X-Interswitch-Authorization-Domain"] = "ISW";
  }

  if (isProd) {
    headers[xsrfTokenHeader] = xsrfToken;
  }

  const defer = new Promise(function (resolve, reject) {
    axios({
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      url: options.url,
      method: options.method,
      headers: headers,
      baseURL: options.baseURL,
      params: options.params,
      data: isEnCoded ? formUrlEncoded(options.data || {}) : options.data || {},
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          //
        }
        if (error.response) {
          reject(error.response);
        } else {
          reject("ERROR_NO_RESPONSE");
        }
      });
  });

  return defer;
};

request.get = (options) => {
  options.method = "GET";
  return request.make(options);
};

request.post = (options) => {
  options.method = "POST";
  return request.make(options);
};

request.patch = (options) => {
  options.method = "PATCH";
  return request.make(options);
};

request.delete = (options) => {
  options.method = "DELETE";
  return request.make(options);
};

request.cancel = () => {
  cancel && cancel();
};

export default request;



// WEBPACK FOOTER //
// ./src/api/request.js